/**
 * Checks whether the given text contains a link to figma.com (including subdomains).
 */

const urlRegex = /https?:\/\/[^\s)]+/gi
const bareRegex = /(?:^|\s)([a-zA-Z0-9.-]*figma\.com\/[\w\-./?%&=#]+)/gi

export function containsFigmaLink(text: string): boolean {
  // Quick check to avoid unnecessary work
  if (text.length == 0 || text.indexOf("figma.com") === -1) return false

  // Extract potential URLs, including ones without protocol
  const candidates: string[] = []

  // Match http/https URLs
  let match: RegExpExecArray | null
  while ((match = urlRegex.exec(text)) !== null) {
    candidates.push(match[0])
  }

  // Match bare domains like figma.com/file/...
  let bareMatch: RegExpExecArray | null
  while ((bareMatch = bareRegex.exec(text)) !== null) {
    const raw = bareMatch[1]?.trim()
    if (raw) candidates.push("https://" + raw)
  }

  for (const candidate of candidates) {
    try {
      const u = new URL(candidate)
      const host = u.hostname.toLowerCase()
      if (host === "figma.com" || host.endsWith(".figma.com")) {
        return true
      }
    } catch {
      // ignore invalid URL parse
    }
  }
  return false
}
